import { ReactElement } from 'react';

import { MedicalDataAccessAuthorization, PatientConsentDocument } from '@dreryk/egabinet-patient-frontend-api';

import { SidePanelList, TaskIcon } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../translations';

import { useCreatePatientConsentsAndAuthorizationsListItems } from './PatientConsentsAndAuthorizationsSidePanelList.hooks';

type PatientConsentsAndAuthorizationsSidePanelListProps = {
   readonly patientConsents: PatientConsentDocument[];
   readonly patientAuthorizations: MedicalDataAccessAuthorization[];
};

export const PatientConsentsAndAuthorizationsSidePanelList = (
   props: PatientConsentsAndAuthorizationsSidePanelListProps
): ReactElement => {
   const patientConsentsAndAuthorizationsListItems = useCreatePatientConsentsAndAuthorizationsListItems({
      patientConsents: props.patientConsents,
      patientAuthorizations: props.patientAuthorizations,
   });

   return (
      <SidePanelList
         icon={<TaskIcon />}
         items={patientConsentsAndAuthorizationsListItems}
         noItemsMessage={patientConsentsAndAuthorizationsTranslationKeys.noPatientConsents}
      />
   );
};
